import { ApiService } from './../core/api-service/api.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Signup } from '../models/signup';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SignupService {
  private reqHeader = new HttpHeaders({ "No-Auth": "True" });
  private rootURL: string = environment.baseUrl + 'api/customers/';
  private registerURL: string = this.rootURL + 'users';
  private getTimeZoneURL: string = this.rootURL + 'GetTimeZoneTypes';
  private getStateTypeURL: string = this.rootURL + 'GetAllStateTypes';
  private checkEmailDuplicationURL: string = this.rootURL + 'checkEmailExists/';
  private activatedEmailURL: string = this.rootURL + 'verifyUserEmail/';
  private activatedMobileCodeURL: string = this.rootURL + 'verifyMobileCode/';
  private requestPasswordResetURL = this.rootURL + 'forgetPassword';
  private passwordResetURL = this.rootURL + 'resetPassword/';
  private checkPhoneNumberDuplicationURL = this.rootURL + 'checkPhoneNumberExists/';
  private checkEmailIsVerifiedUrl = this.rootURL + 'customerEmailVerificationInformation/'
  companyDetails: any;
  isAgreementAccept = false;
  showMessage = true;
  private baseUrlAxlePoint: string= environment.baseUrlForAxlePoint;

  constructor(private http: HttpClient, private apiService: ApiService) { }

  checkEmailIsVerified(email: String) {
    return this.http.get(this.checkEmailIsVerifiedUrl + email);
  }

  registerUser(signupDetails: Signup) {
    return this.apiService.post(this.registerURL, signupDetails);
  }

  getTimeZone() {
    return this.http.get(this.getTimeZoneURL);
  }

  getStateType() {
    return this.http.get(this.getStateTypeURL);
  }

  checkEmailDuplication(email: string) {
    return this.http.get(this.checkEmailDuplicationURL + email);
  }

  checkPhoneNumberDuplication(phoneNumber: string) {
    return this.http.get(this.checkPhoneNumberDuplicationURL + phoneNumber);
  }

  verifyEmail(emailCode: string) {
    return this.http.get(this.activatedEmailURL + emailCode);
  }

  verifyMobileCode(mobileCode: string) {
    return this.http.get(this.activatedMobileCodeURL + mobileCode, { responseType: 'text' });
  }

  requestPasswordReset(emailDetails: Signup) {
    return this.http.post(this.requestPasswordResetURL, emailDetails);
  }

  resetPassword(newPwdDetails: Signup, userUniqueCode: string) {
    return this.http.post(this.passwordResetURL + userUniqueCode, newPwdDetails);
  }

  getLatLong(address) {
    return this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + address + "&key=AIzaSyA7HT075AemTDa6k1dVMBPCoIP2J_4bKuw");
  }

  getUsersTimezone(geocode) {
    return this.http.get("https://maps.googleapis.com/maps/api/timezone/json?location=" + geocode.lat + ',' + geocode.lng + "&timestamp=1458000000&key=AIzaSyA7HT075AemTDa6k1dVMBPCoIP2J_4bKuw");
  }

  inviteCustomer(data: any) {
    return this.apiService.post(this.rootURL + "sendCustomerPortalInvites", data);
  }

  getInvitedCustomer(email) {
    return this.http.get(this.rootURL + "getCustomerPortalInvites/" + email);
  }

  getCompanyDetails() {
    return this.companyDetails;
  }

  setCompanyDetails(companyDetails) {
    this.companyDetails = companyDetails;
  }

  updateInviteAcceptedDate(email) {
    return this.http.get(this.rootURL + "updateInviteAcceptedDate/" + email);
  }

  setIsAgreementAccepted(isAgree: boolean) {
    this.isAgreementAccept = isAgree;
  }

  getIsAgreementAccepted() {
    return this.isAgreementAccept;
  }

  setShowMessage(val: boolean) {
    this.showMessage = val;
  }

  getShowMessage() {
    return this.showMessage;
  }

  saveCustomerProfile(companySummaryInformation: any) {
    const headers = new HttpHeaders({
      token: 'TTNFleet2018'
    });
    return this.http.post(this.baseUrlAxlePoint + 'api/alxepoint/customer/profile', companySummaryInformation, { headers: headers });
  }
}
